import React from "react";
import { useI18n } from "../../i18n/I18nContext";
import { CLIENT_LOGOS } from "../../config/site";

export const ClientLogos = () => {
  const { t } = useI18n();
  if (!CLIENT_LOGOS.length) return null;
  return (
    <section className="py-10 lg:py-12" data-testid="client-logos-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <p className="text-center text-slate-400 text-sm sm:text-base tracking-wide mb-6" data-testid="client-logos-heading">
          {t.clients.title}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          {CLIENT_LOGOS.map((l) => (
            <div key={l.name} className="glass rounded-xl px-8 py-4 flex items-center justify-center" data-testid={`client-logo-${l.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <img src={l.src} alt={l.name} className="h-16 sm:h-20 w-auto object-contain" loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
